import { render, staticRenderFns } from "./LinhaHorizontalY.vue?vue&type=template&id=6f96c54a&"
import script from "./LinhaHorizontalY.vue?vue&type=script&lang=js&"
export * from "./LinhaHorizontalY.vue?vue&type=script&lang=js&"
import style0 from "./LinhaHorizontalY.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports